<template>
    <div class="documents-form">
        <file-preview
            v-for="(file, i) in list" 
            :key="i" 
            :file="file" 
            :name="`${name}[${i}]`"
            :scope="scope"
            @remove="removeProcessing(file.id)" />
        <label class="upload-file">
            <div class="btn btn-upload">
                <b>+</b> <slot />
            </div>
            <!-- pdf, doc, docx, png and jpeg -->
            <input
                multiple
                type="file"
                :accept="'image/jpeg,image/png,application/msword,application/pdf,' + 
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'" 
                @change="selectionProcessing($event)">
        </label>
    </div>
</template>

<script>
  import FilePreview from '../common/FilePreview'

  export default {
    components: {FilePreview},
    inject: ['$validator'],
    props: ['list', 'name', 'doc_type', 'scope'],
    methods: {
      selectionProcessing(event) {
        let list = []
        for (let i = 0; i < event.target.files.length; i++) {
          list.push(event.target.files[i])
        }
        this.$store.commit('documents/ADD', { list, doc_type: this.doc_type })
      },
      removeProcessing(id) {
        this.$store.commit('documents/REMOVE', id)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@stylesheets/_vars.scss';

  .documents-form {
    margin-top: 10px;
    .upload-file {
      input {
        display: none;
      }
    }
  }
</style>
